import { render, staticRenderFns } from "./RecentTraining.vue?vue&type=template&id=f4018746&scoped=true&"
import script from "./RecentTraining.vue?vue&type=script&lang=js&"
export * from "./RecentTraining.vue?vue&type=script&lang=js&"
import style0 from "./RecentTraining.vue?vue&type=style&index=0&id=f4018746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4018746",
  null
  
)

component.options.__file = "RecentTraining.vue"
export default component.exports